// extracted by mini-css-extract-plugin
export default {"layout_container":"styles_layout_container__cILhD","body":"styles_body__pUPdh"};